// 1.D.5 Yhteiset asset-naekymien apufunktiot. Pidetaan erikseen jotta
// kunkin voi unit-testata ilman DOMia.

/** Tiedostokoko ihmisen luettavaksi: 0–1023 B → B, 1024+ → KB / MB / GB / TB. */
export function formatBytes(input: number | string | null | undefined): string {
  if (input === null || input === undefined) return "—";
  const bytes = typeof input === "string" ? Number(input) : input;
  if (!Number.isFinite(bytes) || bytes < 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB", "PB"];
  let value = bytes / 1024;
  let i = 0;
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i++;
  }
  const formatted =
    value >= 100 ? value.toFixed(0) : value >= 10 ? value.toFixed(1) : value.toFixed(2);
  return `${formatted} ${units[i]}`;
}

/**
 * Polun naytettavissa oleva muoto: viimeinen kansio + tiedostonimi.
 * "/Users/kimmos/Pictures/2026/Hää/IMG_0001.raw" → "Hää/IMG_0001.raw"
 */
export function pathTail(path: string): string {
  const norm = path.replace(/\\/g, "/").replace(/\/+$/, "");
  const parts = norm.split("/").filter(Boolean);
  if (parts.length === 0) return path;
  if (parts.length === 1) return parts[0]!;
  return `${parts[parts.length - 2]}/${parts[parts.length - 1]}`;
}

/** Polun viimeinen segmentti, esim. tiedostonimi. */
export function basename(path: string): string {
  const norm = path.replace(/\\/g, "/").replace(/\/+$/, "");
  const parts = norm.split("/").filter(Boolean);
  return parts.length > 0 ? parts[parts.length - 1]! : path;
}

/** Lyhyt label thumbnail-placeholderille, esim. tiedostopaatteen iso kirjain. */
export function thumbnailLabel(path: string): string {
  const name = basename(path);
  const dot = name.lastIndexOf(".");
  const ext = dot >= 0 ? name.slice(dot + 1) : name;
  return ext.slice(0, 4).toUpperCase();
}

// Sama lista kuin daemonin enrich.ts:n VIDEO_EXTS. Pidettava sync:ssa.
const VIDEO_EXTS = new Set([".mp4", ".mov", ".mkv", ".avi", ".webm", ".m4v"]);

/**
 * Onko tiedosto video tiedostopaatteen perusteella. Kaytetaan AssetThumbnail:n
 * hover-cycle-previewin liipaisuun — luotettavampi kuin videoCodec joka voi
 * olla null jos MediaInfo epaonnistui (vanhat dogfood-assetit ilman
 * mediainfo-rikastusta).
 */
export function isVideoPath(path: string): boolean {
  const name = basename(path);
  const dot = name.lastIndexOf(".");
  if (dot < 0) return false;
  return VIDEO_EXTS.has(name.slice(dot).toLowerCase());
}
